import type { CompositePrimaryKey, PrimitivePrimaryKey } from '#layers/data-model/public';

/**
 * Normalize an item key into the string id used by the entitlement wire format.
 * Accepts a raw scalar id or a key object whose `id` segment is taken. A nullish
 * key — or an object whose `id` segment is itself nullish (a composite key with no
 * scalar `id`) — becomes `undefined` rather than the literal string `"undefined"`,
 * so a missing id never forges a wire key that silently fails to match.
 */
export function getKeyId(
	key: PrimitivePrimaryKey | CompositePrimaryKey | { id?: PrimitivePrimaryKey | null } | null | undefined,
): string | undefined {
	if (key == null) return undefined;
	if (typeof key === 'object') return key.id == null ? undefined : String(key.id);
	return String(key);
}
